import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import './user-list-container.styles.scss'
import { getAllUsersFromDb } from '@/utils/getAdminData';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faMagnifyingGlass, faPen, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import SearchBar from '@/components/SHARED/search-bar/search-bar.component';

const UserListContainer = ({
  owners
}) => {

  const [userList, setUserList] = useState(null);
  const [filteredList, setFilteredList] = useState([]);
  const [userCategory, setUserCategory] = useState('owners');
  const [displayCount, setDisplayCount] = useState(30);
  const [sortBy, setSortBy] = useState({
    'column': 'lName',
    'direction': 'asc'
  });
  let userListener;
  const userListRef = useRef({});
  const navigate = useNavigate();

  useEffect(() => {
    changeDocumentTitle('Gamably Admin | Manage Users');

    return () => {
      if (userListener) userListener();
    }
  }, [])

  useLayoutEffect(() => {
    if (!owners || !userCategory) return;
    if (userCategory === 'owners') {
      setUserList(owners);
    }
  }, [owners, userCategory])

  useEffect(() => {
    if (!userList) return;
    search()
  }, [userList, sortBy])

  function search() {
    console.log('searching');
    const searchEl = document.getElementById('search-bar');
    let text = '';
    if (searchEl) {
      text = searchEl.value.toLowerCase();
    }
    let tempFilteredList = [];
    if (userList) {
      tempFilteredList = Object.values(userList)
        .filter((u) => {
          let match = true;
          if (
            text &&
            (
              !u.fName.toLowerCase().includes(text) &&
              !u.lName.toLowerCase().includes(text) &&
              !u.email.toLowerCase().includes(text)
            )
          ) {
            match = false;
          }
          return match;
        })
    }
    // handle sorting
    if (sortBy.column) {
      tempFilteredList.sort((a, b) => {
        let aValue;
        let bValue;
        if (sortBy.column === 'ts_joined' || sortBy.column === 'gamesCreated') {
          aValue = a[sortBy.column];
          bValue = b[sortBy.column];
        } else {
          aValue = a[sortBy.column].toLowerCase();
          bValue = b[sortBy.column].toLowerCase();
        }
        if (aValue < bValue) return sortBy.direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortBy.direction === 'asc' ? 1 : -1;
        return 0;
      });
      console.log(tempFilteredList)
    }

    setFilteredList(tempFilteredList);
  }

  return (
    <div className='user-list-container'>
      <div className='user-list g-card'>
        <div className='section-title with-icon'>
          <span>Manage Users</span>
          {/* <button
            className='g-button med-btn'
            title="Create New User"
            onClick={() => navigate('/admin/users/create')}
          >
            Create New User
            <FontAwesomeIcon
              icon={faPlusCircle} />
          </button> */}
        </div>
        <hr />
        <div className='meta'>
          {filteredList.length} Users
        </div>
        <div className="g-space-1"></div>
        <div className='search-bar-container'>
          <SearchBar search={search} idLabel='search-bar' />
        </div>
        <div className="g-space-1"></div>
        <div className="table-container">
          <table className='g-table'>
            <thead>
              <tr>
                <th></th>
                <th>
                  <button className='g-button text-only column-button'
                    onClick={() => setSortBy({
                      column: 'lName',
                      direction:
                        (sortBy.column === 'lName' && sortBy.direction === 'asc') ? 'desc' : 'asc'
                    })}>
                    Last Name
                    {
                      sortBy.column === 'lName' &&
                      <FontAwesomeIcon
                        icon={faCaretDown}
                        className={`sort-icon ${sortBy.column === 'lName' ? sortBy.direction : ''}`} />
                    }
                  </button>
                </th>
                <th>
                  <button className='g-button text-only column-button'
                    onClick={() => setSortBy({
                      column: 'fName',
                      direction: (sortBy.column === 'fName' && sortBy.direction === 'asc') ? 'desc' : 'asc'
                    })}>
                    First Name
                    {
                      sortBy.column === 'fName' &&
                      <FontAwesomeIcon
                        icon={faCaretDown}
                        className={`sort-icon ${sortBy.column === 'fName' ? sortBy.direction : ''}`} />
                    }
                  </button>
                </th>
                <th>
                  <button className='g-button text-only column-button'
                    onClick={() => setSortBy({
                      column: 'email',
                      direction: (sortBy.column === 'email' && sortBy.direction === 'asc') ? 'desc' : 'asc'
                    })}>
                    Email
                    {
                      sortBy.column === 'email' &&
                      <FontAwesomeIcon
                        icon={faCaretDown}
                        className={`sort-icon ${sortBy.column === 'email' ? sortBy.direction : ''}`} />
                    }
                  </button>
                </th>
                <th>
                  <button className='g-button text-only column-button'
                    onClick={() => setSortBy({
                      column: 'gamesCreated',
                      direction: (sortBy.column === 'gamesCreated' && sortBy.direction === 'asc') ? 'desc' : 'asc'
                    })}>
                    Games Created
                    {
                      sortBy.column === 'gamesCreated' &&
                      <FontAwesomeIcon
                        icon={faCaretDown}
                        className={`sort-icon ${sortBy.column === 'gamesCreated' ? sortBy.direction : ''}`} />
                    }
                  </button>
                </th>
                <th>
                  <button className='g-button text-only column-button'
                    onClick={() => setSortBy({
                      column: 'ts_joined',
                      direction: (sortBy.column === 'ts_joined' && sortBy.direction === 'asc') ? 'desc' : 'asc'
                    })}>
                    Joined
                    {
                      sortBy.column === 'ts_joined' &&
                      <FontAwesomeIcon
                        icon={faCaretDown}
                        className={`sort-icon ${sortBy.column === 'ts_joined' ? sortBy.direction : ''}`} />
                    }
                  </button>
                </th>
                
              </tr>
            </thead>
            <tbody>
              {
                filteredList.length > 0
                  ?
                filteredList
                  .map((u, i) => {
                    if (i >= displayCount) return null;
                    return (
                      <tr key={u.appId}>
                        <td>
                          <button className='g-button small-btn'>
                            <FontAwesomeIcon
                              icon={faMagnifyingGlass}
                              onClick={() => navigate(`/admin/users/${u.appId}`)} />
                          </button>
                        </td>
                        <td>{u.lName}</td>
                        <td>{u.fName}</td>
                        <td>{u.email}</td>
                        <td>{u.gamesCreated}</td>
                        <td>{format(new Date(u.ts_joined), 'Pp')}</td>
                      </tr>
                    )
                  })
                  :
                  <tr>
                    <td colSpan={6} className='no-results'>
                      No users found.
                    </td>
                  </tr>
              }
            </tbody>
          </table>
          </div>
        <div className="g-space-1"></div>
        <div className='center-col'>
          {filteredList.length > displayCount &&
            <button
              className='g-button med-btn'
              onClick={() => setDisplayCount(displayCount + 30)}
            >
              Load More
            </button>
          }
        </div>
      </div>
    </div>
  )
}

export default UserListContainer